import React, { useState } from "react";
import "./WhatYouGet.css";
import Navbar from "./Navbar";
import FooterSection from "../FooterSection/FooterSection";

const data = [
  {
    title: "Explore Detailed Itineraries",
    content: "Day-wise travel plans with timing, routes & sightseeing flow",
  },
  {
    title: "Local Information",
    content: "Local tips, transport guidance, food spots and hidden gems",
  },
  {
    title: "Complete Cost Breakdown",
    content: "Stay, travel, meals and activities cost explained clearly",
  },
  {
    title: "Alternative Route & Plan Options",
    content: "Multiple way yo explore the same destination",
  },
  {
    title: "Destination Deep-Dive",
    content:
      "Famous places+ unique and lesser known location(not just touristy spots)",
  },
  {
    title: "Book Anytime (Optional)",
    content: "Flexible booking support whenever you are ready to travel",
  },
  {
    title: "Travel Ideas & Suggestions",
    content: "Weekend idea,budget trip,luxury option and hidden gems",
  },
  {
    title: "Custom Trip Guidance",
    content: "Modify days,budget or themes as per your need",
  },
  {
    title: "Plan 1",
    content: "ZikRme planners+smart travel planning without booking pressure",
  },
  {
    title: "Plan 2",
    content: "Premium plan with full customization and priority support",
  },
];

const WhatWeGet = () => {
  // NEW STATE (fix)
  const [openStates, setOpenStates] = useState(Array(data.length).fill(false));

  const toggle = (index) => {
    const updated = Array(data.length).fill(false); // close all first
    updated[index] = !openStates[index]; // open only clicked
    setOpenStates(updated);
  };

    return (
      <div>
        <Navbar/>
    <div className="what-container">
      <h1 className="main-heading">ZikRme Pro Travel Plans</h1>

      <p className="sub-heading">
        Not Ready to Book? No Problem! Use ZikRme Pro Travel Plans
      </p>

      <h2 className="section-title">What You Get:</h2>

      <div className="grid">
        {data.map((item, index) => (
          <div
            key={index}
            className={`accordion ${openStates[index] ? "active" : ""}`}
            onClick={() => toggle(index)}
          >
            <div className="accordion-header">
              <span>{item.title}</span>
              <span className="arrow-icon">{openStates[index] ? "▲" : "▼"}</span>
            </div>

            {openStates[index] && (
              <p className="accordion-content">{item.content}</p>
            )}
          </div>
        ))}
      </div>
        </div>
        <FooterSection/>
            </div>
  );
};

export default WhatWeGet;
